import 'css-chunksrc/client/scenes/eventCreation/form/participantsList/resource/user/styles.scss';export default {
  "resource": "_resource_va7jc_1",
  "user": "_user_va7jc_12",
  "avatar": "_avatar_va7jc_24",
  "name": "_name_va7jc_36",
  "title": "_title_va7jc_42"
};